
import { PropsWithChildren } from 'react'
import { Box } from "@chakra-ui/react";
import { maxWidth} from "../../config";
import ResponsiveFooter from '../../components/Footer/ResponsiveFooter';
import { NAV_ITEMS } from '../../data/data';
import { NavBar } from '../../components/NavBar';



export default function NonStickyNavAndFooter({ children }: PropsWithChildren) {
    return (
        <Box position="relative" zIndex={1}>
            <Box className="nav-bar" position={"absolute"} minHeight={"5rem"}
                height={"10vh"} w="100vw" />
            <Box maxW={maxWidth}
                position={"absolute"}
                margin={"auto"}
                left={0}
                right={0}
                zIndex={99999}>
                <NavBar navItems={NAV_ITEMS} sticky={false}
                    maxWidth={maxWidth} logoUrl="https://s3.ap-south-1.amazonaws.com/swadharmaspandana.org/logov4.png" />
            </Box>
            <Box maxW={maxWidth}
                margin={"auto"}
                pt={{ base: "5rem", md: "6rem" }}>
                {children}
                <br />
                <br />
            </Box>
            <ResponsiveFooter/>
        </Box>
    )
}